import { useParams } from "react-router-dom";

import { FormCb } from "components/Risk/formdata";
import { BasePage } from "components/BasePage/BasePage";
import { BackofficeRiskEdit } from "components/Backoffice/Risk/Edit";
import { useRiskTemplate } from "components/RiskTemplates/hooks/useRiskTemplate";
import { useUpdateRiskTemplateForEdit } from "components/RiskTemplates/hooks/useUpdateRiskTemplateForEdit";

interface RiskTemplateRouteParams {
  riskId: string;
}

export const EditRiskTemplate = () => {
  const { riskId } = useParams<RiskTemplateRouteParams>();
  const { riskTemplate, isLoading } = useRiskTemplate(riskId);
  const updateRiskTemplate = useUpdateRiskTemplateForEdit(riskId);

  const handleSubmit = (formData: FormCb) => {
    updateRiskTemplate(formData);
  };

  return (
    <BasePage
      breadcrumbItems={[
        { label: "Dashboard", location: "/risk-templates" },
        {
          label: "form.risk_template.list",
          location: "/risk-templates",
        },
        {
          label: riskTemplate?.payload?.blueprint_name || riskId,
          location: `/risk-templates/${riskId}`,
        },
      ]}
      loading={isLoading}
    >
      <div>
        {riskTemplate && (
          <BackofficeRiskEdit
            risk={riskTemplate.payload}
            customSubmitHandler={handleSubmit}
          />
        )}
      </div>
    </BasePage>
  );
};

export default EditRiskTemplate;
